<template>
  <Section
    v-bind="$attrs"
    :title="title"
    :shouldShowSearch="shouldShowSearch"
    :toolbarActions="toolbarActions"
    @onClicked="(val) => $emit(val)"
    :isPrimary="isPrimary"
    icon="event"
    :isLoading="isLoading"
  >
    <v-data-table
      :headers="headers"
      :items="activityList"
      item-key="id"
      class="elevation-1"
      :rows-per-page-items="[15, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">
          {{
            _entityPropertyValueByName({
              entityList: activityTypeList,
              idKey: "id",
              idValue: props.item.typeId,
              propertyKey: "name",
            })
          }}
          {{ _formatJavascriptDate({ date: props.item.dateTimePerformedOn }) }}
        </td>
        <td class="text-xs-left">
          {{
            _entityPropertyValueByName({
              entityList: assetStatusList,
              idKey: "id",
              idValue: props.item.statusId,
              propertyKey: "name",
              emptyText: "N/A",
            })
          }}
        </td>
        <td class="text-xs-left">
          {{
            _entityPropertyValueByName({
              entityList: locationList,
              idKey: "id",
              idValue: props.item.locationId,
              propertyKey: "name",
              emptyText: "N/A",
            })
          }}
        </td>
        <td class="text-xs-left">
          {{
            _entityPropertyValueByName({
              entityList: userList,
              idKey: "id",
              idValue: props.item.userIdPerformedBy,
              propertyKey: "name",
            })
          }}
        </td>
        <td class="text-xs-left">
          <template
            v-if="props.item.attachmentList && props.item.attachmentList.length"
          >
            <div
              v-for="attachment in props.item.attachmentList"
              :key="attachment.id"
            >
              {{ attachment.fileName }}
            </div>
          </template>
        </td>
        <td class="text-xs-right">
          <ControlButton
            text="View"
            depressed
            :disabled="isLoading"
            @onClicked="
              $emit('onClickViewActivity', { activityId: props.item.id })
            "
          />
        </td>
      </template>
    </v-data-table>
  </Section>
</template>

<script>
import mixinAssetHelper from '../../../../common/mixins/mixinAssetHelper'

import Section from '../../../../common/components/layouts/Section'
import ControlButton from '../../../../common/components/controls/ControlButton'

export default {
  inheritAttrs: false,
  components: {
    Section,
    ControlButton,
  },
  mixins: [mixinAssetHelper],
  props: {
    title: {
      type: String,
      default: 'Activity List',
    },
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
    shouldShowSearch: {
      type: Boolean,
    },
    isPrimary: {
      type: Boolean,
      default: true,
    },
    activityList: {
      type: Array,
      required: true,
    },
    activityTypeList: {
      type: Array,
      required: true,
    },
    locationList: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
    modelList: {
      type: Array,
      required: true,
    },
    assetStatusList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    headers: [
      { text: 'Activity', value: 'dateTimeEpochPerformedOn', sortable: false },
      {
        text: 'Equipment Status',
        value: 'statusId',
        align: 'left',
        sortable: false,
      },
      { text: 'Location', value: 'locationId', align: 'left', sortable: false },
      {
        text: 'Performed By',
        value: 'userIdPerformedBy',
        align: 'left',
        sortable: false,
      },
      { text: 'Attachments', align: 'left', sortable: false },
      { text: '', sortable: false },
    ],
  }),
  computed: {},
  methods: {},
}
</script>
